import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

// Session notification preferences with explicit text-message consent.
export function NotifyPrefsCard() {
  const [p, setP] = useState(null);
  useEffect(() => { api.get("/me/notify-prefs").then((r) => setP({ ...r.data, timezone: r.data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone })).catch(() => {}); }, []);
  if (!p) return null;
  const save = () => api.put("/me/notify-prefs", p).then(() => toast.success("Notification settings saved")).catch((e) => toast.error(e?.response?.data?.detail || "Couldn't save"));
  return (
    <div className="bg-white rounded-3xl border border-[var(--line)] p-5 space-y-3" data-testid="notify-prefs">
      <p className="font-serif text-xl flex items-center gap-2"><Bell className="w-5 h-5 text-[var(--gold)]" /> Session notifications</p>
      <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={p.email} onChange={(e) => setP({ ...p, email: e.target.checked })} data-testid="notify-prefs-email" /> Email me bookings, reminders and "your host is ready"</label>
      <label className="flex items-start gap-2 text-sm"><input type="checkbox" className="mt-1" checked={p.sms} onChange={(e) => setP({ ...p, sms: e.target.checked })} data-testid="notify-prefs-sms" />
        <span>Text me too. I agree to receive appointment texts from Locked In Forever at the number below. Message and data rates may apply. Reply STOP to opt out.</span></label>
      <input value={p.phone || ""} onChange={(e) => setP({ ...p, phone: e.target.value })} placeholder="Mobile number" className="input-luxe !py-2 text-sm" data-testid="notify-prefs-phone" />
      <p className="text-xs text-[var(--muted)]">Times are shown in {p.timezone}.</p>
      <button onClick={save} className="btn-gold !py-2" data-testid="notify-prefs-save">Save</button>
    </div>
  );
}
